import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

type Option = { value: string; label: string };

const toOptions = (response: string[]): Option[] => response.map((item) => ({ value: item, label: item }));

export const constantsApi = createApi({
  reducerPath: "constantsApi",
  baseQuery: fetchBaseQuery({
    baseUrl: "https://cdn.monetary-metals.com/client-portal/constants/",
  }),
  endpoints: (builder) => ({
    getHowDidYouHearAboutUsOptions: builder.query<Option[], void>({
      query: () => "how-did-you-hear-about-us.json",
      transformResponse: toOptions,
      keepUnusedDataFor: 3600,
    }),
    getAdvertiserOptions: builder.query<Option[], void>({
      query: () => "advertisers.json",
      transformResponse: toOptions,
      keepUnusedDataFor: 3600,
    }),
    getAffiliateOptions: builder.query<Option[], void>({
      query: () => "affiliates.json",
      transformResponse: toOptions,
      keepUnusedDataFor: 3600,
    }),
    getReferralOptions: builder.query<Option[], void>({
      query: () => "referrals.json",
      transformResponse: toOptions,
      keepUnusedDataFor: 3600,
    }),
  }),
});

export const {
  useGetHowDidYouHearAboutUsOptionsQuery,
  useGetAdvertiserOptionsQuery,
  useGetAffiliateOptionsQuery,
  useGetReferralOptionsQuery,
} = constantsApi;
